<template>
    <div>
        <div class="order">
            <div class="order__info">
                <div class="order__price" :class="{'order__price--line': delivery}">
                    <h4 class="order__price-name">{{ productNameComputed }}</h4>
                    <span class="order__price-count">{{ productPrice | priceFormat }} {{ prices.currency.symbol }}</span>
                </div>

                <div v-if="delivery"
                     :class="{'opacity opacity--30': plateAttachment === true}"
                     class="order__delivery">
                    <div>
                        <h4 class="order__delivery-title">{{ delivery.methodName }}</h4>

                        <button class="btn link order__delivery-btn" @click="back"><span>{{ $lang('Delivery.order.changeMethod') }}</span></button>
                    </div>

                    <span class="order__delivery-price">{{ delivery.price | priceFormat }} {{ prices.currency.symbol }}</span>
                </div>

                <ul v-if="delivery"
                    :class="{'opacity opacity--30': plateAttachment === true}"
                    class="order__data">
                    <li class="order__data-item" v-if="pickupSelected">
                        <h4 class="order__data-item__title">{{ $lang('Delivery.order.partnerName') }}</h4>

                        <p>{{ delivery.partnerName}}</p>
                    </li>

                    <li class="order__data-item">
                        <h4 class="order__data-item__title">{{ orderAddressTitle }}</h4>

                        <p>{{ delivery.address}}</p>
                    </li>

                    <li class="order__data-item">
                        <h4 class="order__data-item__title">{{ $lang('Delivery.order.time') }}</h4>

                        <p v-if="delivery.period">
                            {{ delivery.period }} {{ $lang('Delivery.order.boxberry.time') }}
                        </p>

                        <p v-else>
                            {{ $lang('Delivery.order.cemetery.time') }}
                        </p>
                    </li>

                    <li class="order__data-item">
                        <h4 class="order__data-item__title">{{ $lang('Delivery.order.phone') }}</h4>
                        <p>+7 495 230 12 35</p>
                    </li>

                    <li v-if="delivery.workschedule" class="order__data-item">
                        <h4 class="order__data-item__title">{{ $lang('Delivery.order.workingHours') }}</h4>
                        <p>{{ delivery.workschedule }}</p>
                    </li>
                </ul>

                <div v-if="locale === 'ru' && delivery && (cemeterySelected || pickupSelected)">
                    <label class="order__attachment">
                        <el-checkbox class="order__attachment-check order__check" v-model="plateAttachment"></el-checkbox>

                        <span class="order__attachment-info">
                            <h4 class="order__attachment-info__title">{{ $lang('Delivery.order.plateAttach') }}</h4>

                            <p>{{ $lang('Delivery.order.plateAttach.text') }}</p>
                        </span>

                        <div class="order__attachment-price">{{ prices.plateAttachment.price | priceFormat }} {{ prices.currency.symbol }}</div>
                    </label>
                </div>
            </div>

            <div class="order__total">
                <div>{{ $lang('Delivery.order.sum') }} </div>

                <div class="order__total-price">
                    <div>{{ sum | priceFormat }} {{ prices.currency.symbol }}</div>

                    <div v-if="promoCode.isVisible && promoCode.products[0].pivot.discount" class="order__discount-block">
                        <span class="order__discount-before">{{ sumBeforeDiscound }} {{ prices.currency.symbol }}</span>
                        <span class="order__discount">
                            <span>–</span>
                            <span>{{promoCode.products[0].pivot.discount}}</span>
                            <span>{{promoCode.products[0].pivot.currency === '%' ? '%' : prices.currency.symbol}}</span>
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="promoCode.isVisible" class="order__promo-code">
                <div class="order__promo-code-title" v-html="$lang('DeliveryOrder.promoCode.title')"></div>

                <div
                    v-if="notify.message"
                    class="notify notify--w-303 order__promo-code-notify"
                    :class="{'notify--error': notify.isError}"
                >
                    {{ notify.message }}
                </div>

                <div class="order__promo-code-form">
                    <el-input
                        slot="reference"
                        :placeholder="$lang('DeliveryOrder.promoCode.enter')"
                        class="input input--big input--w303"
                        v-model="promoCode.code"
                        :readonly="promoCode.isActive"
                    />

                    <button
                        class="btn btn--big btn--border-bg order__promo-code-btn"
                        @click="promoCode.isActive ? removePromoCode() : submitPromoCode()"
                    >
                        {{ promoCode.isActive ? $lang('DeliveryOrder.promoCode.remove') : $lang('DeliveryOrder.promoCode.submit')}}
                    </button>
                </div>
            </div>

            <div class="order__buttons">
                <div v-if="notPaid">
                    <p class="order__not-paid-msg"> {{ $lang('DeliveryOrder.returnFromRobokassaMessage') }} </p>

                    <div class="order__not-paid-buttons">
                        <button dusk="to-pay" class="btn btn--middle btn--main-bg" @click.prevent="submit">
                            {{ $lang('DeliveryOrder.payAgain') }}
                        </button>

                        <button class="btn btn--middle btn--border-bg order__back-btn" @click="back">
                            {{ $lang('DeliveryOrder.changeOrder') }}
                        </button>
                    </div>
                </div>

                <div v-else>
                    <button dusk="to-pay" class="btn btn--middle btn--main-bg" @click.prevent="submit">
                        {{ $lang('Delivery.order.pay') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";
import ApiService from "../../api/api";

export default {
    props: {
        delivery: {
            type: Object,
            default: null
        },
        order: {
            type: Object,
            default: null
        },
        productName: {
            type: String,
            default: null
        },
        productPrice: {
            default: 0
        },
        paymentType: {
            default: null
        },
        copyright: {
            default: false
        },
        notPaid: {
            type: Boolean,
            default: false
        },
        hiddenPromoCode: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            plateAttachment: false,
            plateAttachmentPrice: window.laravel.prices.plateAttachment,
            prices: window.laravel.prices,
            locale: window.laravel.locale,
            promoCode: {
                id: null,
                isVisible: window.laravel.locale === 'ru' && !this.hiddenPromoCode,
                isActive: false,
                code: null,
                products: [
                    {
                        pivot: []
                    }
                ]
            },
            notify: {
                isError: false,
                message: ''
            },
            paymentTypes: window.laravel.paymentTypes,
            promoCodeProducts: window.laravel.promoCodeProducts
        }
    },
    computed: {
        productNameComputed() {
            return this.delivery ? this.productName : this.productName + ' ' + this.$lang('Delivery.order.productNameWithOutTable');
        },
        boxberrySelected() {
          return (this.delivery && this.delivery.method === 'boxberry');
        },
        cemeterySelected() {
            return (this.delivery && this.delivery.method === 'cemetery');
        },
        pickupSelected() {
            return (this.delivery && this.delivery.method === 'pickup');
        },
        orderAddressTitle() {
            if (this.boxberrySelected) {
                return  this.$lang('Delivery.order.address');
            } else if (this.cemeterySelected) {
                return this.$lang('Delivery.order.locationAddress');
            } else {
                return this.$lang('Delivery.order.pickupAddress');
            }
        },
        sum() {
            let productPrice = parseFloat(this.productPrice);
            let discount = this.promoCode && this.promoCode.products.length
                ? this.promoCode.products[0].pivot.discount
                : null;

            if (this.promoCode.isVisible && discount) {
                if (this.promoCode.products[0].pivot.currency === '%') {
                    discount = productPrice / 100 * discount;
                }

                productPrice -= discount;
            }

            if (this.delivery) {
                return this.boxberrySelected
                    ? productPrice + parseFloat(this.delivery.price)
                    : productPrice + (this.plateAttachment ? parseFloat(this.prices.plateAttachment.price) : 0);
            } else {
                return productPrice - parseFloat(this.prices.noTable.price);
            }
        },
        sumBeforeDiscound() {
            if (this.delivery) {
                return this.boxberrySelected
                    ? parseFloat(this.productPrice) + parseFloat(this.delivery.price)
                    : parseFloat(this.productPrice) + (this.plateAttachment ? parseFloat(this.prices.plateAttachment.price) : 0);
            } else {
                return parseFloat(this.productPrice) - parseFloat(this.prices.noTable.price);
            }
        }
    },
    created() {
        this.setModal(800);
        let utm = window.laravel.promoCode;

        if (utm && window.laravel.locale === 'ru') {
            this.promoCode.isVisible = !utm;
            this.getPromoCodeByUtm(utm);
        }

        if (this.order) {
            this.plateAttachment = this.order.plateAttachment;
        }
    },
    methods: {
        ...mapMutations('create', [
            'setModal'
        ]),
        back() {
            this.$emit('back');
        },
        submit() {
            this.$emit('onSubmit', {
                sum: this.sum,
                plateAttachment: this.plateAttachment,
                promoCodeId: this.promoCode.id
            });
        },
        submitPromoCode() {
            if (!this.promoCode.code) {
                this.notify.isError = true;
                this.notify.message = this.$lang('DeliveryOrder.promoCode.enter');
                return;
            }

            this.promoCode.isActive = true;

            ApiService.get('/promo-codes/showBy', {code: this.promoCode.code, productId: this.getPromoCodeProductId()})
                .then((response) => {
                    if (!response.data.active) {
                        this.notify.isError = true;
                        this.notify.message = this.$lang('DeliveryOrder.promoCode.inactive');
                        return;
                    }

                    if (response.data.not_started) {
                        this.notify.isError = true;
                        this.notify.message = this.$lang('DeliveryOrder.promoCode.notStarted');
                        this.promoCode.isActive = false;
                        return;
                    }

                    if (response.data.expired) {
                        this.notify.isError = true;
                        this.notify.message = this.$lang('DeliveryOrder.promoCode.expired');
                        this.promoCode.isActive = false;
                        return;
                    }

                    if (response.data.limit_exceeded) {
                        this.notify.isError = true;
                        this.notify.message = this.$lang('DeliveryOrder.promoCode.maxUsesReached');
                        this.promoCode.isActive = false;
                        return;
                    }

                    this.promoCode = Object.assign(this.promoCode, response.data);
                    this.notify.isError = false;
                    this.notify.message = this.$lang('DeliveryOrder.promoCode.activated');
                })
                .catch((error) => {
                    this.notify.isError = true;
                    this.notify.message = this.$lang('DeliveryOrder.promoCode.error');
                });
        },
        getPromoCodeByUtm(utm) {
            ApiService.get('/promo-codes/showBy', {utm: utm, productId: this.getPromoCodeProductId()})
                .then((response) => {
                    this.promoCode = Object.assign(this.promoCode, response.data);
                });
        },
        getPromoCodeProductId() {
            let promoCodeProductId = null;

            switch(this.paymentType) {
                case this.paymentTypes.page:
                    promoCodeProductId = this.copyright ? this.promoCodeProducts.fullWithCopyright : this.promoCodeProducts.full;
                    break;
                case this.paymentTypes.burial:
                    promoCodeProductId = this.copyright ? this.promoCodeProducts.burialWithCopyright : this.promoCodeProducts.burial;
                    break;
                case this.paymentTypes.table:
                    promoCodeProductId = this.promoCodeProducts.table;
                    break;
            }

            return promoCodeProductId;
        },
        removePromoCode() {
            this.$set(this.promoCode, 'isActive', false);
            this.$set(this.promoCode, 'code', null);
            this.$set(this.promoCode.products[0].pivot, 'discount', 0);
            this.notify.message = null;
        }
    }
}
</script>
